



















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BooleanProp } from '@pjn/vue-core/component';
import MenuItem from '@pjn/core/model/app/MenuItem';
import { User } from '@pjn/core/model/app/User';
import { newTab } from '@pjn/utils/browser';
import UserIcon from '../user/UserIcon.vue';
import SidebarItem from './SidebarItem.vue';

/**
 * Menu lateral.
 * 
 * Se usa en mobile pero puede usarse en desktop.
 * Incluye logica para mostrar MenuItems y el menu de autenticacion.
 * 
 */
@Component({ components: { UserIcon, SidebarItem } })
export default class Sidebar extends Vue {
  
  /** Muestra u oculta el menu lateral */
  @Prop() value: boolean;

  /** Info del usuario a mostrar (o null si no hay usuario) */
  @Prop()
  user: User | null;

  /** Items del menu */
  @Prop({ type: Array, default: () => [] })
  items: MenuItem[];

  /** Item seleccionado del menu  */
  @Prop({ required: false })
  selected: MenuItem | null;

  /** Ancho del sidebar */
  @Prop({ default: 300 }) width: number;

  /** El drawer queda debajo de la barra de herramientas de la aplicación */
  @BooleanProp(false) clipped: boolean;

  /** Un drawer flotante no tiene un contenedor visible (no hay border-right) */
  @BooleanProp(false) floating: boolean;

  /** 
   * Condensa el ancho del navigation drawer.
   * También acepta el modificador .sync. Con esto, el drawer re-abrirá cuando se haga click en él  
   */
  @BooleanProp(false) miniVariant: boolean;

  /** El drawer permanece visible independientemente del tamaño de la pantalla */
  @BooleanProp(false) permanent: boolean;

  /** Reduce la altura de los items */
  @BooleanProp(false) dense: boolean;

  onItemClick(item: MenuItem) {
    this.$emit('itemClick', item);
  }

  get itemsSinPerfil() {
    if(!this.userMenuItem) return this.items;
    return this.items.filter(i => i !== this.userMenuItem);
  }

  get userMenuItem() {
    if(!this.items) return undefined;
    return this.items.find(m => m.label.toLowerCase() === 'perfil');
  }

  get userItems(): MenuItem[] {
    return [
      this.userMenuItem || { id: 'perfil', label: 'Perfil', icon: 'person', url: 'http://portalpjn.pjn.gov.ar'},
      {id: 'logout', label: 'Salir', icon: 'power_settings_new'}
    ]
  }

  onUserItemClick(item: MenuItem) {
    if(item.id === 'logout') {
      return this.$emit('logout');
    } else if(item.id === 'perfil') {
      if(item.url && item.url.startsWith('http')) return this.onProfileClick();
      this.onItemClick(item);
    }
  }

  onProfileClick() {
    newTab('http://portalpjn.pjn.gov.ar', 'Navegando a la pagina de perfil');
  }
}
